module.exports = __webpack_public_path__ + "img/stock4.b79d80ba.png";